export default __webpack_public_path__ + "static/media/iNovel.a6ab7665.png";